export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-slider-scale/index.js